export * from './logo.dto'